import script from "./EditMatchupTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditMatchupTable.vue?vue&type=script&setup=true&lang=ts"

import "./EditMatchupTable.vue?vue&type=style&index=0&id=22ea97bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ea97bb"]])

export default __exports__